<template>
  <div
    v-if="product?.description?.html"
    class="giftcard__product-description"
  >
    <pre class="giftcard__product-description-text">{{ product?.description?.html }}</pre>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  product?: {
    description?: {
      html?: string
    }
  }
}>()
</script>

<style>
@import url("~layers/app/components/Product/GiftCard/ProductInfo.css");
</style>
